import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PaymentProcessService,
  PaymentProcessState,
} from '../../../services/payment-process.service';

@Component({
  selector: 'kt-payment-preview-tab',
  templateUrl: './payment-preview-tab.component.html',
  styleUrls: ['./payment-preview-tab.component.scss'],
})
export class PaymentPreviewTabComponent implements OnInit {
  state$: Observable<PaymentProcessState>;
  todayLocalized: string = new Date().toLocaleDateString();

  constructor(private paymentProcessService: PaymentProcessService) {}

  ngOnInit(): void {
    this.state$ = this.paymentProcessService.state$;
  }
  getCardLast4(state: PaymentProcessState): string {
    return (
      `•••• •••• •••• ` +
      (state.payment_method.card_last4 || state.payment_method?.token_data?.data?.card?.last4)
    );
  }
}
